import { useContext } from "react";

import {
	SeasonContext,
	type SeasonContextValue,
} from "@/features/content/content-settings-provider";

export { nextSeason } from "@/features/content/api";

export function useSeason(): SeasonContextValue {
	const value = useContext(SeasonContext);
	if (!value) {
		throw new Error("useSeason must be used inside ContentSettingsProvider");
	}
	return value;
}
